export enum AssemblyDisapprovalType {
  AssemblyProblem = 1,
  LensProblem = 2,
  FrameProblem = 3
}